exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1iKG_{padding:17px 0 0;background-color:#f5f5f5;max-width:1100px;position:relative;z-index:1}._1iKG_,._3T14g{margin:0 auto}._2xHPH{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}.p5UQd{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding-right:20px}._2uDpE{font-size:13px;text-align:left;font-weight:400}._1zgZX{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._2yop2{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"root": "_1iKG_",
	"container": "_3T14g container",
	"flexContainer": "_2xHPH",
	"leftCol": "p5UQd",
	"mainH1": "_2uDpE",
	"headerRow": "_1zgZX",
	"leftHeader": "_2yop2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/commercial/Commercial.css
// module id = 3044
// module chunks = 24